module.exports = __webpack_public_path__ + "static/media/logo-white.5d3a886b.svg";